import { formatNumber } from "./formatNumber.js";

export const formatMoney = (value, currency) => {
  const amount = formatNumber(value);
  const currencyLabel = String(currency || "").trim();
  return currencyLabel ? `${currencyLabel} ${amount}` : amount;
};
